import {createFileRoute, redirect} from '@tanstack/react-router';
import {useEffect} from 'react';

import {pushRoute, replaceRoute, Route as RouteEnum} from '~utils/routeUtil';

import {BaseLayout} from '~components/_layout/BaseLayout';
import {DefectStudio} from '~components/defect-studio/DefectStudio';
import {useIsDefectStudioAvailable} from '~components/defect-studio/useIsDefectStudioAvailable';
import {ModelProvider} from 'src/contexts/ModelProvider';
import {isEmbeddedAppConfigured} from 'src/embed/apps';

export const Route = createFileRoute('/model/samples/defect-studio')({
  beforeLoad: () => {
    // Nothing to show when the studio is not deployed for this environment —
    // send the user to the models overview instead of an empty shell.
    if (!isEmbeddedAppConfigured('defect-studio')) {
      throw redirect({to: RouteEnum.models as any});
    }
  },
  component: ModelSamplesDefectStudioPage,
});

function ModelSamplesDefectStudioPage(): JSX.Element | null {
  const {isDefectStudioAvailable, isReady} = useIsDefectStudioAvailable();
  const isDefectStudioHidden = isReady && !isDefectStudioAvailable;

  useEffect(() => {
    // Back to the samples of the same model (the query keeps its `modelID`); replace, so the
    // browser's back button does not land on this page again.
    if (isDefectStudioHidden) {
      replaceRoute(RouteEnum.modelSamples);
    }
  }, [isDefectStudioHidden]);

  if (!isDefectStudioAvailable) {
    return null;
  }

  return (
    <ModelProvider mode='model-pages'>
      <BaseLayout fullscreen onClose={() => pushRoute(RouteEnum.modelSamples)}>
        <DefectStudio />
      </BaseLayout>
    </ModelProvider>
  );
}
